import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Typography,
  TextField,
  Button,
  Grid
} from '@mui/material';

export default function CreateCompany() {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [website, setWebsite] = useState('');

  const postData = () => {
    fetch('https://smartlight.bhtelecom.ba:3000/api/companies', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        address,
        email,
        phoneNumber,
        website
      })
    }).then(() => {
      navigate('/dashboard/CompaniesListAll'); // vrati se na listu firmi
    });
  };

  return (
    <div style={{
      backgroundColor: '#0b1446',
      minHeight: '100vh',
      width: '100%',
      padding: '20px'
    }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 600, width: '100%', backgroundColor: '#1a237e', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>F</Avatar>}
            title={<Typography variant="h6">Nova firma</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Naziv firme"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                  required
                />
                <TextField
                  label="Adresa"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Telefon"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Web stranica"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              sx={{ mt: 3, backgroundColor: '#3949ab' }}
              onClick={postData}
            >
              Spasi firmu
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}